var _linearGradient, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcoforestControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    x2: 24,
    y1: 5,
    y2: 43.1073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff13b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea3c3a"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#43b17e",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m32 42.7592c5.6838-2.0269 9-6.4129 9-12.2334 0-15.1732-14.622-25.5258-17.1376-25.5258 0 0 4.0093 5.69 4.0093 9.6413 0 3.9514-1.2971 6.2432-2.5156 6.2432s-2.2012-.3556-3.6555-4.8207c-1.7504-5.3738-6.2497-8.10027-6.2497-8.10027.8385 2.64737 2.5156 8.71667 2.5156 11.81457 0 3.8724-.5896 5.611-2.948 5.611s-3.459-1.7386-3.459-3.5168c0-1.4225.4455-3.0689.6682-3.7142-1.7425 1.3039-5.2277 4.9866-5.2277 12.3677 0 6.574 3.7698 10.8432 10 12.5841v-10.9682l7.5-6.1417 7.5 6.1417z",
    fill: "url(#a)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoforestControl);
export default __webpack_public_path__ + "static/media/ecoforest-control.4c8ff96a5698e66decd8500b39b7ef7f.svg";
export { ForwardRef as ReactComponent };